import styled from '@emotion/styled';

const Seventh:React.FC<any> = () => {
  return (
    <Container>
      <BodyImg>
        <Img src="/images/newLanding/home/alarmtalk.png"/>
      </BodyImg>
      <Title className="top">깜빡할 걱정 마세요
        <br/>때가 되면 알림을 드려요</Title>
      <SmallText>종일 정신없는 일상이잖아요.<br/>힘든건 저희가 알아서 도와드릴께요.</SmallText>
    </Container>
  )
};

export default Seventh;

const Container = styled.div`
  width: 100%;
  background-color: #fcf7ef;
  /* min-height: 100vh; */
`;

const BodyImg = styled.div`
  width: 100%;
`;

const Img = styled.img`
  width: 100%;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
  &.top{
    margin: 40px 20px 30px;
  }

  &.bottom {
    margin: 50px 20px 30px;
  }
`;

const SmallText = styled.div`
  font-size: 16px;
  margin: 30px 20px 190px;
  line-height: 1.4;
`;
